(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dbc-cinematic-reel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dbc-cinematic-reel')) {
    customElements.define('dbc-cinematic-reel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = [...this.querySelectorAll('[data-reel-slide]')];
        this.nav = [...this.querySelectorAll('[data-reel-index]')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.inView = true;
        this.hovered = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplay = this.dataset.autoplay === 'true' && !this.motion.matches;
        this.delay = Math.max(6000, Number(this.dataset.interval) || 8000);
        this.toggle = this.querySelector('[data-reel-toggle]');
        this.slides.forEach(slide => { slide.hidden = false; });
        this.querySelector('[data-reel-controls]').hidden = false;
        this.nav.forEach((button, index) => button.addEventListener('click', () => this.go(index, true)));
        this.querySelector('[data-reel-prev]').addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-reel-next]').addEventListener('click', () => this.go(this.index + 1, true));
        this.toggle.addEventListener('click', () => { this.autoplay = !this.autoplay; this.schedule(); });
        this.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') { this.hovered = true; this.schedule(); } });
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); });
        this.addEventListener('focusin', event => { if (!this.toggle.contains(event.target)) { this.autoplay = false; this.schedule(); } });
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        });
        this.addEventListener('pointerdown', event => {
          if (event.pointerType === 'mouse' || event.target.closest('a,button')) return;
          this.touch = { x:event.clientX, y:event.clientY };
        }, {passive:true});
        this.addEventListener('pointerup', event => {
          if (!this.touch) return;
          const x = event.clientX - this.touch.x;
          const y = event.clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y) * 1.4) this.go(this.index + (x < 0 ? 1 : -1), true);
        }, {passive:true});
        this.addEventListener('pointercancel', () => { this.touch = null; });
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
          if (index >= 0) this.go(index, true);
        });
        this.onVisibility = () => this.schedule();
        this.onMotion = () => { if (this.motion.matches) this.autoplay = false; this.schedule(); };
        document.addEventListener('visibilitychange', this.onVisibility);
        this.motion.addEventListener('change', this.onMotion);
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, {threshold:.15});
        this.observer.observe(this);
        this.go(0, false);
      }
      go(index, manual) {
        this.index = (index + this.slides.length) % this.slides.length;
        if (manual) this.autoplay = false;
        this.slides.forEach((slide, current) => {
          const active = current === this.index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
          this.nav[current].classList.toggle('is-active', active);
          if (active) this.nav[current].setAttribute('aria-current', 'true');
          else this.nav[current].removeAttribute('aria-current');
        });
        this.querySelector('[data-reel-count]').textContent = String(this.index + 1).padStart(2, '0');
        if (manual) this.querySelector('[data-reel-announcement]').textContent = this.slides[this.index].getAttribute('aria-label') + ': ' + this.nav[this.index].textContent.trim();
        const nextImage = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
        if (nextImage) nextImage.loading = 'eager';
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        this.toggle.setAttribute('aria-label', this.autoplay ? this.toggle.dataset.pause : this.toggle.dataset.play);
        this.toggle.querySelector('[data-pause-icon]').hidden = !this.autoplay;
        this.toggle.querySelector('[data-play-icon]').hidden = this.autoplay;
        if (this.autoplay && this.inView && !this.hovered && !document.hidden) this.timer = setTimeout(() => this.go(this.index + 1, false), this.delay);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.observer) this.observer.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.motion && this.onMotion) this.motion.removeEventListener('change', this.onMotion);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbc-club-signup"]) return;
  try {
    
  if (!customElements.get('dbc-club-signup')) {
    customElements.define('dbc-club-signup', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.tab = this.querySelector('.dbc-club-tab');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        const signal = this.controller.signal;
        const get = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
        const set = (storage, key, value) => { try { window[storage].setItem(key, value); } catch {} };
        const remove = (storage, key) => { try { window[storage].removeItem(key); } catch {} };
        const prefix = 'dbc.club.v1.';
        const status = this.querySelector('[data-form-status]')?.dataset.formStatus;
        const pending = Number(get('sessionStorage', prefix + 'pending'));
        const ownResponse = pending > 0 && Date.now() - pending < 600000;
        this.subscribed = this.dataset.subscribed === 'true' || get('localStorage', prefix + 'subscribed') === '1';
        this.dismissed = get('localStorage', prefix + 'dismissed') === '1';
        const editor = Boolean(window.Shopify?.designMode);
        this.tab.hidden = this.subscribed;
        const open = () => {
          if (this.dialog.open || !this.isConnected) return;
          this.returnFocus = document.activeElement;
          this.dialog.showModal();
          this.tab.hidden = true;
          this.dialog.querySelector('h2').focus({ preventScroll: true });
          if (!editor) set('sessionStorage', prefix + 'shown', '1');
          clearTimeout(this.timer);
        };
        const close = () => this.dialog.close();
        this.tab.addEventListener('click', open, { signal });
        this.querySelectorAll('.dbc-club-close, [data-club-done]').forEach(button => button.addEventListener('click', close, { signal }));
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); close(); }, { signal });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          this.dismissed = true;
          if (!editor) set('localStorage', prefix + 'dismissed', '1');
          this.tab.hidden = this.subscribed;
          if (this.returnFocus?.isConnected && !this.returnFocus.hidden) this.returnFocus.focus({ preventScroll: true });
        }, { signal });
        this.querySelector('form')?.addEventListener('submit', () => {
          if (!editor) set('sessionStorage', prefix + 'pending', String(Date.now()));
        }, { signal });
        if (editor) {
          if (this.dataset.editorPreview === 'true') open();
          return;
        }
        if (status === 'success') {
          this.subscribed = true;
          this.tab.hidden = true;
          set('localStorage', prefix + 'subscribed', '1');
        }
        if (ownResponse && (status === 'success' || status === 'error')) {
          remove('sessionStorage', prefix + 'pending');
          open();
          return;
        }
        if (this.subscribed) return;
        const page = window.location.pathname;
        let views = Number(get('sessionStorage', prefix + 'views')) || 0;
        if (get('sessionStorage', prefix + 'page') !== page) {
          views += 1;
          set('sessionStorage', prefix + 'views', String(views));
          set('sessionStorage', prefix + 'page', page);
        }
        const desktop = window.matchMedia('(min-width: 750px)');
        if (!desktop.matches || this.dismissed || get('sessionStorage', prefix + 'shown') === '1') return;
        if (views < (Number(this.dataset.pageThreshold) || 2)) return;
        let retries = 0;
        const attempt = () => {
          if (!desktop.matches || this.dismissed || this.subscribed || !this.isConnected) return;
          const focused = document.activeElement;
          const typing = focused?.matches('input, textarea, select, [contenteditable="true"]');
          const otherOverlay = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], cart-drawer.active, .drawer.active, .menu-drawer-container[open]')).some(element => element !== this.dialog && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden' && element.getAttribute('aria-hidden') !== 'true');
          if (document.visibilityState !== 'visible' || typing || otherOverlay) {
            if (retries++ < 12) this.timer = setTimeout(attempt, 5000);
            return;
          }
          open();
        };
        this.timer = setTimeout(attempt, (Number(this.dataset.delay) || 20) * 1000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbc-discovery-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dbc-scent-counter')) {
    customElements.define('dbc-scent-counter', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = [...this.querySelectorAll('[data-scent-tab]')];
        this.panels = [...this.querySelectorAll('[data-scent-panel]')];
        if (!this.tabs.length) return;
        this.querySelector('[data-scent-tabs]').setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', event => { event.preventDefault(); this.activate(index); });
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.activate(next);
            this.tabs[next].focus();
          });
        });
        this.activate(0);
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
          if (index >= 0) this.activate(index);
        });
      }
      activate(index) {
        this.tabs.forEach((tab, current) => {
          const selected = current === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[current].hidden = !selected;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbc-shows"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dbc-show-list')) {
    customElements.define('dbc-show-list', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.loadShows();
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
      async loadShows() {
        const status = this.querySelector('[role="status"]');
        const grid = this.querySelector('.dbc-show-grid');
        const controller = this.controller;
        const timeout = setTimeout(() => controller.abort(), 12000);
        const node = (tag, className, text) => {
          const element = document.createElement(tag);
          element.className = className;
          element.textContent = text;
          return element;
        };
        const link = (label, url) => {
          const anchor = node('a', '', label);
          anchor.href = url;
          anchor.target = '_blank';
          anchor.rel = 'noopener';
          return anchor;
        };
        try {
          const url = new URL('https://www.googleapis.com/calendar/v3/calendars/' + encodeURIComponent(this.dataset.calendar) + '/events');
          url.search = new URLSearchParams({key: this.dataset.key, singleEvents: 'true', orderBy: 'startTime', timeMin: new Date().toISOString(), maxResults: '50', showDeleted: 'false'});
          const response = await fetch(url, {signal: controller.signal, credentials: 'omit'});
          if (!response.ok) throw new Error('Calendar unavailable');
          const data = await response.json();
          if (!Array.isArray(data.items)) throw new Error('Invalid calendar response');
          const count = Math.min(6, Math.max(1, Number(this.dataset.count) || 3));
          const events = data.items.filter(event => event.status !== 'cancelled' && (event.start?.date || event.start?.dateTime)).slice(0, count);
          grid.replaceChildren();
          for (const event of events) {
            const allDay = Boolean(event.start.date);
            const zone = allDay ? 'UTC' : (event.start.timeZone || this.dataset.zone || 'America/Chicago');
            const start = new Date(allDay ? event.start.date + 'T00:00:00Z' : event.start.dateTime);
            const end = new Date(allDay ? event.end.date + 'T00:00:00Z' : event.end.dateTime);
            if (allDay) end.setUTCDate(end.getUTCDate() - 1);
            const dateFormat = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {month:'short', day:'numeric', year:'numeric', timeZone:zone});
            const dates = dateFormat.format(start) === dateFormat.format(end) ? dateFormat.format(start) : dateFormat.format(start) + ' – ' + dateFormat.format(end);
            const card = node('article', 'dbc-show-card', '');
            card.append(node('p', 'dbc-show-date', dates), node('h3', '', event.summary || this.dataset.details));
            const timeFormat = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {hour:'numeric', minute:'2-digit', timeZone:zone, timeZoneName:'short'});
            card.append(node('p', '', allDay ? this.dataset.allDay : timeFormat.format(start) + ' – ' + timeFormat.format(end)));
            if (event.location) card.append(node('p', '', event.location));
            const links = node('div', 'dbc-show-links', '');
            if (event.location) links.append(link(this.dataset.directions, 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(event.location)));
            if (event.htmlLink) {
              const eventUrl = new URL(event.htmlLink);
              if (eventUrl.protocol === 'https:' && ['calendar.google.com', 'www.google.com'].includes(eventUrl.hostname)) links.append(link(this.dataset.details, eventUrl.href));
            }
            card.append(links);
            grid.append(card);
          }
          status.hidden = events.length > 0;
          status.textContent = this.dataset.empty;
        } catch {
          if (this.isConnected) { grid.replaceChildren(); status.hidden = false; status.textContent = this.dataset.error; }
        } finally { clearTimeout(timeout); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
